import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('DrawerWidget').create(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100vh',
    touchAction: 'none',
    pointerEvents: 'none',
    userSelect: 'none',
    WebkitOverflowScrolling: 'touch',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,

    willChange: 'transform',
    zIndex: 999,
  },
  content: {
    height: '100%',
    pointerEvents: 'all',
    overflow: 'scroll',
    backgroundColor: '#1C1C21',
    // boxShadow: '0px -2px 20px 0px rgba(74,107,252,0.39)',
  },
  overlay: {
    transition: '.5s ease',
    '&[data-active="true"]': {
      // backgroundColor: '#EE000020',
      position: 'absolute',
      backdropFilter: 'blur(20px)',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 100,
      pointerEvents: 'all',
    },
    '&[data-active="false"]': {
      position: 'absolute',

      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: -100,
      pointerEvents: 'none',
    },
  },
}))
